import React, {Component} from "react";
import styles from './FJResourcesElementSearch.module.less'
import FJElementSearchInput from './FJElementSearchInput'
import FJElementSearchHistory from './FJElementSearchHistory'
import FJElementStore from "../../../store/FJElementStore";

class FJResourcesSearchCommon extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowSearchHistory: false,
      searchValue: '',
      popularList: []
    }
    this.input = React.createRef();
  }

  componentDidMount() {
    this.setState({
      popularList: ["birthday","business","arrow","emoji","fashion","music","sport","social","holiday","food","shape","travel"]
    })
  }

  onChangeInput = (event) => {
    this.setState({
      searchValue: event.target.value,
    }, () => {
      if (this.state.searchValue === '') {
        this.props.backElement();
      }
    })
  }

  inputOnBlur = (event) => {
    event.preventDefault();
    this.setState({
      isShowSearchHistory: false
    })
  }

  inputOnFocus = (event) => {
    event.preventDefault();
    this.setState({
      isShowSearchHistory: true
    })
  }

  _onSearch = (value) => {
    if (value.trim() === '') {
      this.setState({searchValue: ''});
    } else {
      this.input.current.blur();
      this.setState({searchValue: value, isShowSearchHistory: false}, () => {
				this.props.searchResult && this.props.searchResult(value);
        }
      );
    }
  };

  inputOnKeyUp = (event) => {
    switch (event.keyCode) {
      case 13:
        this._onSearch(this.state.searchValue);
        break;
      case 27:
        this.input.current.blur();
        break;
			case 8:
				if (!this.state.searchValue.length) this.props.backElement();
				break;
      default:
        break;
    }
  }

  onClickClearInputValue = (event) => {
    event.stopPropagation();
    this.setState({searchValue: '',}, () => {
      this.props.backElement();
    });
  }

  clearHistory = (event) => {
    event.preventDefault();
    FJElementStore.clearSearchHistory();
    this.setState({isShowSearchHistory: false}, () => {
      this.input.current.blur();
    });
  }

  render() {

    let {
      searchValue,
      popularList,
      isShowSearchHistory
    } = this.state;

    let {
      style,
			placeholder,
			showHistory = true
    } = this.props;

    return (
      <div className={styles.search_container} style={style}>
        <FJElementSearchInput style={{display: searchValue !== '' ? 'block' : 'none'}}
                              onChangeInput={this.onChangeInput}
                              inputOnKeyUp={this.inputOnKeyUp}
                              inputRef={this.input}
                              onClickClearInputValue={this.onClickClearInputValue}
                              searchValue={searchValue}
                              onBlur={this.inputOnBlur}
                              onFocus={this.inputOnFocus}
															placeholder={placeholder}
        />
				{
					showHistory && (
						<FJElementSearchHistory popularList={popularList}
																		isShow={isShowSearchHistory}
																		onSearch={this._onSearch}
																		history={FJElementStore.allSearchHistory()}
																		clareHistory={this.clearHistory}
						/>
					)
				}
      </div>
    )
  }
}


export default FJResourcesSearchCommon;